import { Col, Row } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  AntdTab,
  Box,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../../components";
import { SideStyles, SideTemplates } from "./SideTabs/SideTabs";
import styles from "./customTemplate.module.css";
import DragableComp from "../../../../components/DragableComp/DragableComp";

import img3 from "../../../../assets/staticImages/templateImg.png";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { useLocation, useNavigate } from "react-router-dom";
import { toBlob, toCanvas, toJpeg, toPng } from "html-to-image";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";
import { useDispatch } from "react-redux";
import { showLoading } from "../../../../Store/Actions/GeneralActions";

function CustomizeTemplate() {
  const { state } = useLocation();
  const containerRef = useRef(null);
  const tempRef = useRef();
  const [slectedIndex, setslectedIndex] = useState();
  const [resize, setResize] = useState(false);
  const [TempData, setTempData] = useState(state?.templateData);
  const [TextsList, setTextsList] = useState([
    {
      text: "Wedding Invitation",
      style: {
        fontSize: 14,
        fontWeight: "bold",
        zIndex: 4,
        color: "#000000",
      },
    },
  ]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onAddText = () => {
    setTextsList([
      ...TextsList,
      {
        text: "Wedding Invitation",
        style: {
          fontSize: 14,
          fontWeight: "bold",
          zIndex: 4,
          color: "#000000",
        },
      },
    ]);
  };

  const ChangeText = (value) => {
    let cpylist = [...TextsList];
    cpylist.splice(slectedIndex, 1, {
      ...TextsList[slectedIndex],
      text: value,
    });
    setTextsList(cpylist);
  };

  const tabs = [
    {
      key: "1",
      label: "Styles",
      children: (
        <SideStyles
          TextsList={TextsList}
          setTextsList={setTextsList}
          slectedIndex={slectedIndex}
          setResize={setResize}
          resize={resize}
          onAddText={onAddText}
        />
      ),
    },
    {
      key: "2",
      label: "Templates",
      children: (
        <>
          <SideTemplates setTempData={setTempData} />
        </>
      ),
    },
  ];

  const onButtonClick = useCallback(() => {
    // console.log('tempRef',tempRef)
    if (tempRef.current === null) {
      return;
    }
    dispatch(showLoading());
    toBlob(tempRef.current, {
      style: {
        backgroundImage: `url(${`https://www.bestdayever.me/api/downloadFile?path=${TempData?.image}`})`,
        imagePlaceholder: `https://www.bestdayever.me/api/downloadFile?path=${TempData?.image}`,
      },

      type: "png",
    }).then(function (blob) {
      console.log("blob", blob);
      const file = new File([blob], `${TempData?.name}-greeting-template.png`);
      dispatch(
        EventPlanningMiddleware.createTemplate({
          name: `${TempData?.name}`,
          image: file,
        })
      ).then((data) => navigate(-2));
    });
  }, [tempRef]);

  return (
    <Row>
      <Col className={styles.leftCont}>
        <Box boxClass={styles.sideBox}>
          <AntdTab items={tabs} centered={true} titleClass={styles.tabTitle} />
        </Box>
      </Col>
      <Col className={styles.rightContent}>
        <Row className={styles.contHead}>
          <Col>
            <TextComponent
              text={TempData?.name}
              textClass={styles.contHeading}
            />
          </Col>
          <Col>
            <SubmitButton
              title="Save Template"
              btnClass={styles.saveBtn}
              onClick={() => onButtonClick()}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center" }}>
          <div
            ref={containerRef}
            className={styles.container}
            // className={styles.container}
            // style={{ backgroundImage: `url(${})` }}
          >
            <div
              ref={tempRef}
              style={{
                height: "-webkit-fill-available",
              }}
              // style={{ backgroundImage: `url(${TempData?.image})` }}
            >
              <img
                src={`https://www.bestdayever.me/api/downloadFile?path=${TempData?.image}`}
                alt=""
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "-webkit-fill-available",
                }}
              />
              {TextsList.map((data, i) => (
                <RenderDragableList
                  containerRef={containerRef}
                  data={data}
                  setslectedIndex={setslectedIndex}
                  slectedIndex={slectedIndex}
                  i={i}
                  ChangeText={ChangeText}
                  resize={resize}
                />
              ))}
            </div>
          </div>
        </Row>
      </Col>
    </Row>
  );
}

const RenderDragableList = ({
  data,
  containerRef,
  setslectedIndex,
  slectedIndex,
  i,
  ChangeText,
  resize,
}) => {
  const textRef = useRef(null);
  const divRef = useRef(null);

  const { width, height } = useWindowDimensions();

  const handleOutsideClick = (e) => {
    if (
      divRef?.current &&
      !divRef?.current.contains(e.target) &&
      containerRef?.current.contains(e.target)
    ) {
      setslectedIndex(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <DragableComp
      containerRef={containerRef}
      resize={resize}
      //   initialX={
      //     "50%"
      //     // width < 578
      //     //   ? 70
      //     //   : width < 921
      //     //   ? 120
      //     //   : width < 1025
      //     //   ? 160
      //     //   : width < 1281
      //     //   ? 250
      //     //   : 350
      //   }
      //   initialY={
      //     "50%"
      //     // width < 578
      //     //   ? 70
      //     //   : width < 921
      //     //   ? 120
      //     //   : width < 1025
      //     //   ? 160
      //     //   : width < 1281
      //     //   ? 250
      //     //   : 350
      //   }
    >
      <div ref={divRef}>
        <textarea
          ref={textRef}
          value={data.text}
          className={`${styles.heading} ${
            slectedIndex == i && styles.selectText
          }`}
          style={{
            ...data.style,
            resize: resize ? "both" : "none",
            cursor: resize ? "" : "grabbing",
          }}
          onChange={(e) => ChangeText(e.target.value)}
          //   style={data.style}
          onClick={() => setslectedIndex(i)}
        />
      </div>
    </DragableComp>
  );
};

export default CustomizeTemplate;
